import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all page translations
import {
  commonTranslations,
  navTranslations,
  authTranslations,
  registerTranslations,
  projectsTranslations,
  interviewTranslations,
  profileTranslations,
  projectDetailTranslations,
  errorsTranslations,
  interviewGuideTranslations,
  createProjectTranslations,
  conversationDetailTranslations,
  conversationalSurveyTranslations,
  liveSupervisionTranslations,
  apiKeysTranslations,
  careerProjectTranslations,
  careerAssessmentTranslations,
  careerCvTranslations,
  homeTranslations
} from './pages/index.js';

// Helper function to combine translations by language
const combineTranslations = (language) => {
  return {
    common: commonTranslations[language] || {},
    nav: navTranslations[language] || {},
    auth: authTranslations[language] || {},
    register: registerTranslations[language] || {},
    projects: projectsTranslations[language] || {},
    interview: interviewTranslations[language] || {},
    profile: profileTranslations[language] || {},
    projectDetail: projectDetailTranslations[language] || {},
    errors: errorsTranslations[language] || {},
    interviewGuide: interviewGuideTranslations[language] || {},
    createProject: createProjectTranslations[language] || {},
    conversationDetail: conversationDetailTranslations[language] || {},
    conversationalSurvey: conversationalSurveyTranslations[language] || {},
    liveSupervision: liveSupervisionTranslations[language] || {},
    apiKeys: apiKeysTranslations[language] || {},
    careerProject: careerProjectTranslations[language] || {},
    careerAssessment: careerAssessmentTranslations[language] || {},
    careerCv: careerCvTranslations[language] || {},
    home: homeTranslations[language] || {}
  };
};

// Build resources for all supported languages
const resources = {
  en: { translation: combineTranslations('en') },
  zh: { translation: combineTranslations('zh') },
  fr: { translation: combineTranslations('fr') },
  nb: { translation: combineTranslations('nb') },
  nl: { translation: combineTranslations('nl') },
  de: { translation: combineTranslations('de') },
  es: { translation: combineTranslations('es') },
  pt: { translation: combineTranslations('pt') },
  ja: { translation: combineTranslations('ja') },
  ar: { translation: combineTranslations('ar') },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    // Add configuration for nested keys
    keySeparator: '.',
    nsSeparator: false,
    returnEmptyString: false,
    returnNull: false
  });

export default i18n;
